
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitoprayagrajcab() {



    const cardData =
    {
        keyword: 'Mumbai to prayagraj cab booking',
        heading: 'Skyline Cabs: Mumbai to prayagraj cab booking',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Prayagraj Cab Service for a smooth and timely journey. Whether you are traveling for business, a spiritual visit, or leisure, our well-maintained vehicles and professional drivers ensure a stress-free ride.​​',

        top: 'Top Places to Visit in prayagraj with Skyline Cabs',

"topPlaces": [
    {
        "title": "Triveni Sangam",
        "description": "The Triveni Sangam is the confluence of three holy rivers – the Ganges, Yamuna, and the mythical Saraswati. It is one of the most sacred places in India, where pilgrims come to take a holy dip. It’s also the site of the famous Kumbh Mela, which attracts millions of devotees."
    },
    {
        "title": "Kumbh Mela Grounds",
        "description": "The Kumbh Mela Grounds in Prayagraj is the venue for the world-famous Kumbh Mela, a massive Hindu pilgrimage. The event occurs every 12 years and witnesses millions of people coming together to take a dip in the holy rivers and seek spiritual cleansing."
    },
    {
        "title": "Allahabad Fort",
        "description": "Built by Emperor Akbar in 1583, the Allahabad Fort is a magnificent structure located on the banks of the Yamuna. The fort houses several historical structures, including the Akshaya Vat tree and the Saraswati Koop, and offers a glimpse into the grandeur of Mughal architecture."
    },
    {
        "title": "Anand Bhavan",
        "description": "Anand Bhavan is the ancestral home of the Nehru-Gandhi family and a symbol of India’s independence movement. It has been converted into a museum showcasing the life and contributions of Jawaharlal Nehru, the first Prime Minister of India."
    },
    {
        "title": "Hanuman Mandir",
        "description": "The Hanuman Mandir in Prayagraj is one of the oldest and most revered temples dedicated to Lord Hanuman. Pilgrims visit this temple to seek blessings and experience the spiritual vibrancy of the temple’s atmosphere."
    },
    {
        "title": "Alopi Devi Temple",
        "description": "Dedicated to Goddess Alopi, this temple is believed to be one of the 51 Shakti Peethas. It holds significant religious importance and attracts devotees, especially during Navratri, for its peaceful and divine ambiance."
    },
    {
        "title": "Chandrashekhar Azad Park",
        "description": "Chandrashekhar Azad Park, also known as Company Bagh, is a historical park in Prayagraj dedicated to the memory of the freedom fighter Chandrashekhar Azad. The park is an important landmark and offers a peaceful setting for visitors to relax."
    },
    {
        "title": "Prayagraj Museum",
        "description": "The Prayagraj Museum, located near the Allahabad Fort, showcases a rich collection of artifacts, sculptures, and paintings that reflect the city’s historical and cultural heritage. The museum is a great place for history enthusiasts."
    },
    {
        "title": "Minto Park",
        "description": "Minto Park, also known as the All Saints' Cathedral Park, is a well-maintained garden and a popular place for leisurely walks. It is named after Lord Minto, the then Viceroy of India, and is known for its serene atmosphere."
    },
    {
        "title": "Bade Hanuman Ji Mandir",
        "description": "This massive Hanuman statue is one of the largest of its kind in India. The temple is dedicated to Lord Hanuman and is a prominent religious site in Prayagraj. The towering statue attracts pilgrims and tourists alike."
    }
],

"services": [
    {
      "name": "Mumbai to Prayagraj Cab",
      "description": "Skyline Cabs offers comfortable and reliable cab services from Mumbai to Prayagraj. Travel long-distance with ease and safety in our well-maintained vehicles."
    },
    {
      "name": "Prayagraj Cab Booking from Mumbai",
      "description": "Book your cab from Mumbai to Prayagraj with Skyline Cabs. Enjoy a stress-free journey with professional drivers and seamless booking options."
    },
    {
      "name": "Taxi from Mumbai to Prayagraj",
      "description": "Get a dependable taxi from Mumbai to Prayagraj with Skyline Cabs. Perfect for personal travel, religious visits, or business trips."
    },
    {
      "name": "Prayagraj Darshan Taxi",
      "description": "Explore sacred and historic sites in Prayagraj with Skyline Cabs’ darshan taxi service. Ideal for pilgrims and tourists alike."
    },
    {
      "name": "Mumbai to Prayagraj One Way Cab",
      "description": "Book a one-way cab from Mumbai to Prayagraj with Skyline Cabs. A convenient and affordable solution for your long-distance travel needs."
    }
  ],
  "tableData": [
    ["Mumbai to Prayagraj Cab", "Prayagraj Cab Booking from Mumbai"],
    ["Taxi from Mumbai to Prayagraj", "Prayagraj Darshan Taxi"],
    ["Mumbai to Prayagraj One Way Cab"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Prayagraj Cab Booking",
      "WhyChoosedescription": "Book a reliable and comfortable cab from Mumbai to Prayagraj for a stress-free long-distance journey. Ideal for spiritual trips, family travel, or personal visits to the holy city."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Friendly Cabs",
      "WhyChoosedescription": "Our cabs are equipped for extended journeys, with spacious interiors, air conditioning, and a smooth suspension for a relaxed drive from Mumbai to Prayagraj."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our professional drivers are experienced in long highway drives and offer polite, punctual, and safe service to ensure a pleasant ride to Prayagraj."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We provide competitive rates with full transparency—no hidden charges, just honest fares you can trust for your Mumbai to Prayagraj cab journey."
    },
    {
      "WhyChooseheading": "Ideal for Pilgrimage and Family Travel",
      "WhyChoosedescription": "Whether you're visiting for Kumbh Mela, a holy dip at Triveni Sangam, or family purposes, our cab service is perfectly suited for devotional and personal travel needs."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are sanitized before every trip and maintained to high standards to ensure comfort, safety, and hygiene throughout your journey."
    },
    {
      "WhyChooseheading": "Flexible Booking and Travel Options",
      "WhyChoosedescription": "Choose from one-way or round-trip bookings, with flexible timings to match your schedule. Custom packages available for extended stays in Prayagraj."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance and Customer Support",
      "WhyChoosedescription": "Book anytime through our website or customer care helpline. Our support team is available 24/7 to assist with bookings, updates, or travel queries."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Prayagraj with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Prayagraj is easy with Skyline Cabs. You can book online via our website, mobile app, or call our 24/7 customer support. Choose your pickup location in Mumbai, travel date, and vehicle type to confirm your booking.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Prayagraj?',
            answer:
                'The distance from Mumbai to Prayagraj is approximately 1,400 km. Travel time typically ranges from 22 to 26 hours depending on road conditions, route, and stopovers.',
        },
        {
            id: 3,
            question: 'What vehicle options are available for the Mumbai to Prayagraj journey?',
            answer:
                'Skyline Cabs offers a wide range of vehicles including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups or family travel, Tempo Travellers and luxury coaches are also available.',
        },
        {
            id: 4,
            question: 'Are your cab fares from Mumbai to Prayagraj fixed?',
            answer:
                'Yes, our fares are fixed and transparent. The total fare includes vehicle rent, driver allowance, fuel, tolls, and taxes. There are no hidden charges, and you’ll receive the full fare details upfront.',
        },
        {
            id: 5,
            question: 'Is it possible to book a one-way cab to Prayagraj?',
            answer:
                'Yes, you can book a one-way cab or a round-trip depending on your travel requirements. Round-trips are ideal if you plan to return within a few days.',
        },
        {
            id: 6,
            question: 'Is the long-distance travel to Prayagraj safe and comfortable?',
            answer:
                'Absolutely. Skyline Cabs ensures long-distance travel is safe and convenient. Our vehicles are regularly maintained and equipped for comfortable highway journeys. Our drivers are experienced with intercity and pilgrimage routes.',
        },
        {
            id: 7,
            question: 'Are stopovers or overnight halts allowed during the trip?',
            answer:
                'Yes, long-distance trips like this allow for multiple stopovers and overnight halts. You can coordinate these with the driver or mention preferences at the time of booking.',
        },
        {
            id: 8,
            question: 'What are the payment options available?',
            answer:
                'We accept multiple payment methods including UPI, credit/debit cards, net banking, and cash. Online payments are secured through trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Prayagraj booking?',
            answer:
                'Yes, Skyline Cabs offers flexible cancellation and rescheduling policies. You can modify your booking through the app, website, or by calling our customer care.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Mumbai to Prayagraj journey?',
            answer:
                'Skyline Cabs provides reliable, comfortable, and affordable cab services for long-distance travel. With professional drivers, well-maintained vehicles, fixed pricing, and 24/7 support, your journey from Mumbai to Prayagraj will be hassle-free and safe.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Vinod Shukla",
            rating: 5,
            review: "I booked a cab from Mumbai to Prayagraj for my family’s pilgrimage. The car was very clean, and the driver was respectful and alert throughout the long journey. We even stopped at Varanasi for a short darshan!"
        },
        {
            name: "Mrs. Meena Dubey",
            rating: 4,
            review: "Long trip but very smooth! The car was comfortable and well-suited for such a journey. Appreciate the timely pickups and safe driving. Thank you, Skyline Cabs!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Prayagraj Cab Booking",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-prayagraj-cab.jpg",
  "description": "Book Mumbai to Prayagraj cab with Skyline Cabs for a safe and convenient long-distance journey. Choose from AC sedans, SUVs, or luxury cars with verified chauffeurs and 24/7 support at competitive fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8210"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-prayagraj-cab-booking"
  }
};


      
     

    return (
        <div>

<Helmet>
  <title>Mumbai to Prayagraj Cab Booking | Long-Distance Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Prayagraj cab with Skyline Cabs for a safe and convenient long-distance journey. Choose from AC sedans, SUVs, or luxury cars with verified chauffeurs and 24/7 support at competitive fares." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Prayagraj Cab, Prayagraj Taxi from Mumbai, Book Cab to Prayagraj from Mumbai, One Way Cab Mumbai to Prayagraj, AC Sedan Mumbai Prayagraj Taxi, SUV Cab Mumbai to Prayagraj, Luxury Cab Mumbai to Prayagraj, Mumbai to Prayagraj Long Distance Cab, Skyline Cabs Prayagraj Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/106.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoprayagrajcab;